import API from "./api";

const asArray = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.items)) return data.items;
  return [];
};

export const getAdminCheckins = async () => {
  const res = await API.get("/admin/checkins");
  return asArray(res.data);
};

export const getAdminCheckin = async (id) => {
  const res = await API.get(`/admin/checkins/${id}`);
  return res.data;
};

export const getAdminReservationCheckin = async (reservationId) => {
  const res = await API.get(`/admin/checkins/reservation/${reservationId}`);
  return res.data;
};

export const confirmAdminReservationCheckin = async (reservationId, data) => {
  const res = await API.post(`/admin/checkins/reservation/${reservationId}/confirm`, data);
  return res.data;
};

export const deleteAdminCheckinPhoto = async (photoId) => {
  const res = await API.delete(`/admin/checkins/photos/${photoId}`);
  return res.data;
};
